export const clientContactInformation = {
  name: "Elisabeth Neumann",
  company: "Gardensavvy",
  phone: "(647) 229-0998",
  email: "elisabeth@gardensavvy.ca",
};
